import { render, staticRenderFns } from "./exchangeDetail.vue?vue&type=template&id=7f3823b0"
import script from "./exchangeDetail.vue?vue&type=script&lang=js"
export * from "./exchangeDetail.vue?vue&type=script&lang=js"
import style0 from "./exchangeDetail.vue?vue&type=style&index=0&id=7f3823b0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports